import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonImg,
  IonItem,
  IonItemDivider,
  IonLabel,
  IonList,
  IonModal,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import ReactPlayer from "react-player/lazy";

import AppHeader from "components/Header/AppHeader";

import config from "config";
import { isBreakerRound } from "services/util";
import Spacer from "components/spacer";

interface props {
  quizConfig: any;
}

const Questions: React.FC<props> = ({ quizConfig }) => {
  const [selectedQuestion, setSelectedQuestion] = useState<any>(null);
  const [questionDetails, setQuestionDetails] = useState<any>({});

  const showQuestion = (indexes: any) => {
    // console.log(indexes.questionIndex);
    setSelectedQuestion(indexes);
  };

  const closeQuestionModal = () => {
    setSelectedQuestion(null);
  };

  const nextQuestion = () => {
    //if question is not the last question in the round
    if (
      selectedQuestion.questionIndex <
      quizConfig.rounds[selectedQuestion.roundIndex]?.questionDetails.length - 1
    ) {
      showQuestion({
        roundIndex: selectedQuestion.roundIndex,
        questionIndex: selectedQuestion.questionIndex + 1,
      });
    } else if (
      selectedQuestion.questionIndex ===
      quizConfig.rounds[selectedQuestion.roundIndex]?.questionDetails.length - 1
    ) {
      //if question is the last question in the round
      //if round is not the last round
      if (selectedQuestion.roundIndex < quizConfig.rounds.length - 1) {
        showQuestion({
          roundIndex: selectedQuestion.roundIndex + 1,
          questionIndex: 0,
        });
        // if round is the last round
      } else if (selectedQuestion.roundIndex === quizConfig.rounds.length - 1) {
        if (quizConfig.format.isCrossword) {
          showQuestion({
            roundIndex: "CW",
            questionIndex: 0,
          });
        } else if (quizConfig.format.hasBreaker) {
          showQuestion({
            roundIndex: "BQ",
            questionIndex: 0,
          });
        } else {
          showQuestion(null);
        }
      }
    } else if (["CW", "BQ"].includes(selectedQuestion.roundIndex)) {
      if (selectedQuestion.roundIndex === "CW") {
        if (
          selectedQuestion.questionIndex <
          quizConfig.puzzle.crosswordQuestions.length - 1
        ) {
          showQuestion({
            roundIndex: "CW",
            questionIndex: selectedQuestion.questionIndex + 1,
          });
        } else if (
          selectedQuestion.questionIndex ===
            quizConfig.puzzle.crosswordQuestions.length - 1 &&
          quizConfig.format.hasBreaker
        ) {
          console.log("breaker question");
          showQuestion({
            roundIndex: "BQ",
            questionIndex: 0,
          });
        }
      } else {
        showQuestion(null);
      }
    } else {
      showQuestion(null);
    }

    //setSelectedQuestion
  };

  useEffect(() => {
    if (selectedQuestion) {
      if (quizConfig.rounds[selectedQuestion.roundIndex]) {
        setQuestionDetails(
          quizConfig.rounds[selectedQuestion.roundIndex].questionDetails[
            selectedQuestion.questionIndex
          ]
        );
      } else {
        if (selectedQuestion.roundIndex === "CW") {
          setQuestionDetails(
            quizConfig.puzzle.crosswordQuestions[selectedQuestion.questionIndex]
          );
        } else if (selectedQuestion.roundIndex === "BQ") {
          console.log("setting question");
          setQuestionDetails(quizConfig.breaker.question);
        }
      }
    }
    //eslint-disable-next-line
  }, [selectedQuestion]);

  const showNext = () => {
    if (selectedQuestion) {
      //if last question and no CW or BQ return false
      //if last CW question and no BQ return false
      //if BQ question return false
      if (
        selectedQuestion.roundIndex === quizConfig.rounds.length - 1 &&
        !quizConfig.format.isCrossword &&
        !quizConfig.format.hasBreaker
      ) {
        return false;
      } else if (
        selectedQuestion.roundIndex === "CW" &&
        selectedQuestion.questionIndex ===
          quizConfig.puzzle.crosswordQuestions.length - 1 &&
        !quizConfig.format.hasBreaker
      ) {
        return false;
      } else if (selectedQuestion.roundIndex === "BQ") {
        return false;
      } else {
        return true;
      }
    } else return false;
  };

  return (
    <>
      <AppHeader title="Questions" />
      <IonContent fullscreen className="ion-padding">
        <div className="container">
          <h2>Question List</h2>
          <IonList lines="full">
            {quizConfig.rounds.map((round: any, i: number) => (
              <div key={i}>
                <Spacer size="30" />
                <IonItemDivider>
                  <IonLabel>
                    Round {round.index + 1}: {round.roundName}
                  </IonLabel>
                </IonItemDivider>
                {round.questionDetails.map((question: any, i: number) => (
                  <IonItem
                    key={i}
                    button
                    onClick={() =>
                      showQuestion({
                        roundIndex: round.index,
                        questionIndex: i,
                      })
                    }
                    detail={true}
                  >
                    <IonLabel>
                      {i + 1}. {question.description}
                    </IonLabel>
                  </IonItem>
                ))}
                {quizConfig.format.hasBreaker && (
                  <>
                    {isBreakerRound(quizConfig, i) && (
                      <>
                        <Spacer size="30" />
                        <IonItemDivider>
                          <IonLabel>BQ</IonLabel>
                        </IonItemDivider>
                        <IonItem>
                          <IonLabel>{quizConfig.breaker.question}</IonLabel>
                        </IonItem>
                      </>
                    )}
                  </>
                )}
              </div>
            ))}
            {quizConfig.format.isCrossword && (
              <>
                <Spacer size="30" />
                <IonItemDivider>
                  <IonLabel>Crossword</IonLabel>
                </IonItemDivider>
                <IonItem>
                  <IonImg
                    src={
                      config.MEDIA_HOST +
                      "media/" +
                      quizConfig.puzzle.blankCrosswordImage
                    }
                    alt="alt"
                    //   style={{ width: "50%" }}
                  />
                </IonItem>
                {quizConfig.puzzle.crosswordQuestions.map(
                  (question: any, i: number) => (
                    <IonItem key={i}>
                      <IonLabel>
                        <strong>R{question.position}</strong>.{" "}
                        <strong>
                          <i>
                            {question.imagePosition}{" "}
                            {question.direction === "x" ? "Across" : "Down"}.
                          </i>
                        </strong>{" "}
                        {question.question}
                      </IonLabel>
                    </IonItem>
                  )
                )}
              </>
            )}
          </IonList>
        </div>
      </IonContent>
      <IonModal
        isOpen={Boolean(selectedQuestion)}
        // trigger="open-select-modal"
        onWillDismiss={closeQuestionModal}
      >
        <IonHeader>
          <IonToolbar>
            {selectedQuestion && (
              <>
                {selectedQuestion?.roundIndex < quizConfig.rounds.length && (
                  <IonTitle>
                    R{selectedQuestion.roundIndex + 1} Q
                    {selectedQuestion.questionIndex + 1} - Question Details
                  </IonTitle>
                )}
                {selectedQuestion?.roundIndex === "CW" && (
                  <IonTitle>
                    CW Q{selectedQuestion.questionIndex + 1} - Question Details
                  </IonTitle>
                )}
                {selectedQuestion?.roundIndex === "BQ" && (
                  <IonTitle>BQ - Question Details</IonTitle>
                )}
              </>
            )}
            <IonButtons slot="end">
              <IonButton onClick={closeQuestionModal}>Cancel</IonButton>
              {showNext() && <IonButton onClick={nextQuestion}>Next</IonButton>}
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        {selectedQuestion?.roundIndex < quizConfig.rounds.length && (
          <IonContent className="ion-padding">
            {questionDetails?.mediaSource && (
              <>
                {questionDetails.mediaSource.includes(".mp4") && (
                  <ReactPlayer
                    url={
                      config.MEDIA_HOST +
                      "media/" +
                      questionDetails?.mediaSource
                    }
                    style={{ maxWidth: "100%" }}
                    controls={true}
                  />
                )}

                {questionDetails.mediaSource.includes(".jpg") && (
                  <IonImg
                    src={
                      config.MEDIA_HOST +
                      "media/" +
                      questionDetails?.mediaSource
                    }
                    alt="alt"
                    //   style={{ width: "50%" }}
                  />
                )}
              </>
            )}

            <h4>{questionDetails?.description}</h4>
            <IonList>
              {questionDetails?.options?.map((answer: any, i: number) => (
                <IonItem key={i}>
                  <IonLabel>{answer}</IonLabel>
                </IonItem>
              ))}
            </IonList>
          </IonContent>
        )}
        {selectedQuestion?.roundIndex === "CW" && (
          <IonContent className="ion-padding">
            {questionDetails && (
              <>
                <IonImg
                  src={
                    config.MEDIA_HOST +
                    "media/" +
                    quizConfig.puzzle.blankCrosswordImage
                  }
                  alt="alt"
                  style={{ maxWidth: "400px", margin: "0 auto" }}
                />
              </>
            )}

            <h4>{questionDetails?.question}</h4>
          </IonContent>
        )}
        {selectedQuestion?.roundIndex === "BQ" && (
          <IonContent className="ion-padding">
            {questionDetails && typeof questionDetails === "string" && (
              <h4>{questionDetails}</h4>
            )}
          </IonContent>
        )}
      </IonModal>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  quizConfig: state.quiz.quizConfig,
});

export default connect(mapStateToProps, {})(Questions);
